import { z } from 'zod';
import { CareDocumentDataSchema } from '../CareDocumentDataSchema';
import { CareDocumentTreatmentDetailsSchema } from '../CareDocumentTreatmentDetailsSchema';
import { CareDocumentResourceSchema } from '../CareDocumentResourceSchema';
import { EndOfCareProfessionalSeenSchema } from './EndOfCareProfessionalSeenSchema';
import { CareDocumentClinicalAndExperienceOutcomesSchema } from '../CareDocumentClinicalAndExperienceOutcomesSchema';
import { EndOfCareSummaryReturnToWorkSchema } from './EndOfCareSummaryReturnToWorkSchema';
import { EndOfCareSummaryExpertSummarySchema } from './EndOfCareSummaryExpertSummarySchema';
import { IObject } from '../../../IObject';
import { requiresCaseReferenceNumber } from '../careDocumentChecks';
import {
  dateValidation,
  fullNameValidation,
  requiredString,
} from '../../../../validation';

export const EndOfCareSummaryDataSchema = CareDocumentDataSchema.extend({
  patient: z.object({
    fullName: fullNameValidation('Patient name is required'),
    dob: dateValidation('Patient date of birth is required'),
    cancerType: requiredString('Cancer type is required'),
    dateOfDiagnosis: dateValidation('Date of diagnosis is required'),
  }),
  perciStartDate: dateValidation('Perci Health start date is required'),
  endOfCareDate: dateValidation('End of care date is required'),

  treatmentDetails: CareDocumentTreatmentDetailsSchema,
  returnToWorkStatus: EndOfCareSummaryReturnToWorkSchema,
  clinicalAndExperienceOutcomes:
    CareDocumentClinicalAndExperienceOutcomesSchema,
  professionalsSeen: z.array(EndOfCareProfessionalSeenSchema),

  additionalSignPosting: z.array(CareDocumentResourceSchema),
  additionalCommunicationNotes: z.string().optional(),

  gip: z.object({
    // Optional: L&G's GIP code. Aviva has none and uses policyNumber instead.
    code: z.string().optional(),
  }),
  policyNumber: z.string().optional(),
  expertFullName: z.string().optional(),
  expertSummary: EndOfCareSummaryExpertSummarySchema,
  dateOfConsultation: dateValidation('Date of consultation is required'),
}).check(requiresCaseReferenceNumber);

export type EndOfCareSummaryData = z.infer<typeof EndOfCareSummaryDataSchema>;
export type EndOfCareSummary = IObject.HasIdTimestamped<EndOfCareSummaryData>;
